import * as React from "react";
import QuickFilter from "../quick-filter";
export default class TimeFilter extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("nav", { className: "event-time-filter" },
            React.createElement("div", { className: "time-header" }, "QUICK FILTERS: "),
            React.createElement("div", { className: "time-quick-filter" },
                React.createElement(QuickFilter, { onClick: () => { this.props.updateTime("THIS MONTH"); }, selected: this.props.timeFilter === "THIS MONTH", title: "THIS MONTH" }),
                React.createElement(QuickFilter, { onClick: () => { this.props.updateTime("ALL EVENTS"); }, selected: this.props.timeFilter === "ALL EVENTS", title: "ALL EVENTS" })),
            React.createElement("button", { className: "btn-primary", onClick: this.props.updateMap }, this.props.toggleMap ? "LIST VIEW" : "MAP VIEW")));
    }
}
;
//# sourceMappingURL=time-filter.js.map